export default __webpack_public_path__ + "static/media/record_bar-purple.87dd36e0.svg";